
import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section className="relative min-h-[520px] flex items-center overflow-hidden pt-20">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/f132ae324ab2997f5edb378114f21b95.jpg"
          alt="Sierra Kustom Professional Services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full py-20">
        <div className="max-w-3xl">
          <nav className="flex items-center gap-2 text-sm mb-8">
            <Link to="/" className="text-white/70 hover:text-white transition-colors cursor-pointer">Home</Link>
            <i className="ri-arrow-right-s-line text-white/50"></i>
            <span className="text-amber-400 font-medium">Services</span>
          </nav>

          <div className="inline-block mb-5 px-5 py-2 bg-white/10 backdrop-blur-md rounded-full border border-white/20">
            <span className="text-white/95 font-medium text-sm tracking-wide">7 Professional Services</span>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white mb-5 leading-tight tracking-tight">
            Our <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-200">Services</span>
          </h1>

          <p className="text-lg text-white/85 leading-relaxed max-w-2xl mb-8">
            From expert trim installation and premium flooring to custom deck building and professional cleaning — Sierra Kustom Inc. delivers quality craftsmanship across Alberta and Mexico.
          </p>

          <div className="flex flex-wrap gap-3">
            <a
              href="tel:7805178242"
              className="bg-white text-gray-900 px-7 py-3.5 rounded-full hover:bg-gray-50 transition-all cursor-pointer flex items-center gap-2.5 font-bold text-sm whitespace-nowrap shadow-2xl group"
            >
              Get Free Quote
              <div className="w-8 h-8 bg-gradient-to-br from-amber-600 to-amber-500 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                <i className="ri-phone-fill text-white text-sm"></i>
              </div>
            </a>
            <a
              href="mailto:Info@sierrakustoms.ca"
              className="border-2 border-white/40 text-white px-7 py-3.5 rounded-full hover:bg-white/10 transition-all cursor-pointer font-semibold text-sm whitespace-nowrap flex items-center gap-2"
            >
              <i className="ri-mail-line"></i>
              Email Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
